export default __webpack_public_path__ + "static/media/Bg1.6636b6a6.jpg";